export default __webpack_public_path__ + "static/media/118.c318a28b.svg";